import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const caseStudiesPathMap = localizePathMap({
	[Locale.cs]: "pripadove-studie",
	[Locale.en]: "case-studies",
});
